module.exports = __webpack_public_path__ + "img/FMS-Passenger.b303b413.png";